import React from 'react';
import PropTypes from 'prop-types';
import LoadsForm from 'refactored/features/order/loads/form/loadsForm';
import { useDispatch, useSelector } from 'react-redux';
import Stop from 'components/form/Stop';
import VehicleExtras from 'components/form/VehicleExtras';
import {
  actions as orderActions,
  selectors as orderSelectors,
} from 'state/order';

const DirectForm = ({ typeOfOrder }) => {
  const dispatch = useDispatch();
  dispatch(orderActions.setDefaults());

  const shipmentKeys = useSelector((state) =>
    orderSelectors.getShipmentKeys(state)
  );

  const shipmentKey = (shipmentKeys && shipmentKeys[0]) || '';
  return (
    <div data-testid="direct-form">
      <LoadsForm shipmentKey={shipmentKey} />
      <Stop
        shipmentKey={shipmentKey}
        stopType="pickup"
        typeOfOrder={typeOfOrder}
      />
      <Stop
        shipmentKey={shipmentKey}
        stopType="dropoff"
        typeOfOrder={typeOfOrder}
      />
      <VehicleExtras />
    </div>
  );
};

DirectForm.propTypes = {
  typeOfOrder: PropTypes.string,
};

DirectForm.defaultProps = {
  typeOfOrder: '',
};

export default DirectForm;
